/**
 * Builds API params object by filtering out undefined/null values
 * Eliminates repetitive if-check patterns in API methods
 *
 * @example
 * ```typescript
 * const params = buildParams({
 *   project: projectId,
 *   type,
 *   search,
 *   isActive: isActive?.toString()
 * })
 * // Returns only defined values: { project: 'id', type: 'value' }
 * ```
 */
export function buildParams(
  params: Record<string, string | number | boolean | undefined | null>
): Record<string, string> {
  const result: Record<string, string> = {}

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = String(value)
    }
  }

  return result
}
